var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _c("header-tabs", { attrs: { active: _vm.$route.path } }),
      _vm._v(" "),
      _c(
        "el-row",
        {
          staticClass: "filter",
          staticStyle: { "margin-top": "20px" },
          attrs: { span: 24 }
        },
        [
          _c(
            "el-col",
            {
              staticStyle: { "border-right": "1px solid #ccc" },
              attrs: { span: 24 }
            },
            [
              _c("div", { staticClass: "galy-header" }, [_vm._v("基本配置")]),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  ref: "form",
                  staticClass: "demo-ruleForm",
                  staticStyle: {
                    "padding-left": "10px",
                    display: "flex",
                    "justify-content": "space-around"
                  },
                  attrs: { model: _vm.form, "label-width": _vm.formLabelWidth }
                },
                [
                  _c(
                    "div",
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "是否开启单件分离:" } },
                        [
                          _c("el-switch", {
                            on: { change: _vm.change1 },
                            model: {
                              value: _vm.form.only_dabiao,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "only_dabiao", $$v)
                              },
                              expression: "form.only_dabiao"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "单件分离是否开启今日配齐:" } },
                        [
                          _c("el-switch", {
                            on: { change: _vm.change2 },
                            model: {
                              value: _vm.form.today_full_allot,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "today_full_allot", $$v)
                              },
                              expression: "form.today_full_allot"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "单件分离是否人工汇集:" } },
                        [
                          _c("el-switch", {
                            attrs: { "inactive-value": 0, "active-value": 1 },
                            on: { change: _vm.changeOneSurpass },
                            model: {
                              value: _vm.form.only_surpass,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "only_surpass", $$v)
                              },
                              expression: "form.only_surpass"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "生成越库波次是否判断波次属性:" } },
                        [
                          _c("el-switch", {
                            attrs: { "inactive-value": 0, "active-value": 1 },
                            on: { change: _vm.changeBoolWaveType },
                            model: {
                              value: _vm.form.is_bool_wave_type,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "is_bool_wave_type", $$v)
                              },
                              expression: "form.is_bool_wave_type"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "是否开启质检分离:" } },
                        [
                          _c("el-switch", {
                            on: { change: _vm.change3 },
                            model: {
                              value: _vm.form.quality_dabiao,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "quality_dabiao", $$v)
                              },
                              expression: "form.quality_dabiao"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "质检分离是否人工汇集:" } },
                        [
                          _c("el-switch", {
                            attrs: { "inactive-value": 0, "active-value": 1 },
                            on: { change: _vm.changeQualitySurpass },
                            model: {
                              value: _vm.form.quality_surpass,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "quality_surpass", $$v)
                              },
                              expression: "form.quality_surpass"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "商品对应订单有备注是否可以生成新的越库波次"
                          }
                        },
                        [
                          _c("el-switch", {
                            attrs: {
                              "inactive-value": "0",
                              "active-value": "1"
                            },
                            on: { change: _vm.changeRemarkNewSurpass },
                            model: {
                              value: _vm.remarkNewSurpass,
                              callback: function($$v) {
                                _vm.remarkNewSurpass = $$v
                              },
                              expression: "remarkNewSurpass"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "是否开启改标分离:" } },
                        [
                          _c("el-switch", {
                            on: { change: _vm.change4 },
                            model: {
                              value: _vm.form.label_dabiao,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "label_dabiao", $$v)
                              },
                              expression: "form.label_dabiao"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "改标分离是否人工汇集:" } },
                        [
                          _c("el-switch", {
                            attrs: { "inactive-value": 0, "active-value": 1 },
                            on: { change: _vm.changeLabelSurpass },
                            model: {
                              value: _vm.form.label_surpass,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "label_surpass", $$v)
                              },
                              expression: "form.label_surpass"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "囤货分离是否人工汇集:" } },
                        [
                          _c("el-switch", {
                            attrs: { "inactive-value": 0, "active-value": 1 },
                            on: { change: _vm.changeStockSurpass },
                            model: {
                              value: _vm.form.stock_surpass,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "stock_surpass", $$v)
                              },
                              expression: "form.stock_surpass"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "是否开启【带配件/套装】分离开关" } },
                        [
                          _c("el-switch", {
                            on: { change: _vm.change5 },
                            model: {
                              value: _vm.form.suit_or_parts_dabiao,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "suit_or_parts_dabiao", $$v)
                              },
                              expression: "form.suit_or_parts_dabiao"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "是否开启囤货分离:" } },
                        [
                          _c("el-switch", {
                            attrs: { "inactive-value": 0, "active-value": 1 },
                            on: { change: _vm.changeStockSeparation },
                            model: {
                              value: _vm.form.stock_dabiao,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "stock_dabiao", $$v)
                              },
                              expression: "form.stock_dabiao"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { staticStyle: { display: "flex", border: "1px solid #ccc" } },
        [
          _c(
            "el-col",
            {
              staticStyle: { "border-right": "1px solid #ccc" },
              attrs: { span: 9 }
            },
            [
              _c("div", { staticClass: "galy-header" }, [
                _vm._v("越库分离配置")
              ]),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  staticStyle: { "padding-left": "10px" },
                  attrs: { model: _vm.surpassForm, "label-width": "290px" }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "是否开启越库分离: ", required: "" } },
                    [
                      _c("el-switch", {
                        attrs: { "inactive-value": 0, "active-value": 1 },
                        model: {
                          value: _vm.surpassForm.surpass_dabiao_open,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.surpassForm,
                              "surpass_dabiao_open",
                              $$v
                            )
                          },
                          expression: "surpassForm.surpass_dabiao_open"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "越库分离单个波次商家数量: ",
                        required: ""
                      }
                    },
                    [
                      _c("el-input-number", {
                        attrs: {
                          size: "small",
                          min: 1,
                          max: 9999,
                          disabled: _vm.surpassForm.surpass_dabiao_open == 0
                        },
                        model: {
                          value: _vm.surpassForm.wave_max_supply_num,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.surpassForm,
                              "wave_max_supply_num",
                              $$v
                            )
                          },
                          expression: "surpassForm.wave_max_supply_num"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "越库分离商品一级分类范围: ",
                        required: ""
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            multiple: "",
                            size: "small",
                            disabled: _vm.surpassForm.surpass_dabiao_open == 0
                          },
                          model: {
                            value: _vm.surpassForm.cat_ids,
                            callback: function($$v) {
                              _vm.$set(_vm.surpassForm, "cat_ids", $$v)
                            },
                            expression: "surpassForm.cat_ids"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: { value: "0", label: "全部" }
                          }),
                          _vm._v(" "),
                          _vm._l(_vm.cats, function(item) {
                            return _c("el-option", {
                              key: item.value,
                              attrs: { label: item.label, value: item.value }
                            })
                          })
                        ],
                        2
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "越库分离单波次件数上限: ", required: "" }
                    },
                    [
                      _c("el-input-number", {
                        attrs: {
                          size: "small",
                          disabled: _vm.surpassForm.surpass_dabiao_open == 0,
                          min: 1
                        },
                        model: {
                          value: _vm.surpassForm.wave_max_piece_num,
                          callback: function($$v) {
                            _vm.$set(_vm.surpassForm, "wave_max_piece_num", $$v)
                          },
                          expression: "surpassForm.wave_max_piece_num"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "VIP中分分组: ", required: "" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            filterable: "",
                            multiple: "",
                            size: "small"
                          },
                          model: {
                            value: _vm.surpassForm.vip_hg,
                            callback: function($$v) {
                              _vm.$set(_vm.surpassForm, "vip_hg", $$v)
                            },
                            expression: "surpassForm.vip_hg"
                          }
                        },
                        _vm._l(_vm.halve_group, function(item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { value: item.value, label: item.label }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "VIP中分分组单个中分任务波次数上限: ",
                        required: ""
                      }
                    },
                    [
                      _c("el-input-number", {
                        attrs: { size: "small", min: 1 },
                        model: {
                          value: _vm.surpassForm.vip_hg_max_wave_num,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.surpassForm,
                              "vip_hg_max_wave_num",
                              $$v
                            )
                          },
                          expression: "surpassForm.vip_hg_max_wave_num"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "库存类型中分位单个中分任务波次数上限: ",
                        required: ""
                      }
                    },
                    [
                      _c("el-input-number", {
                        attrs: { size: "small", min: 0 },
                        model: {
                          value: _vm.surpassForm.stock_hg_max_wave_num,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.surpassForm,
                              "stock_hg_max_wave_num",
                              $$v
                            )
                          },
                          expression: "surpassForm.stock_hg_max_wave_num"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.saveSurpass }
                        },
                        [_vm._v("保存")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            {
              staticStyle: { "border-right": "1px solid #ccc" },
              attrs: { span: 8 }
            },
            [
              _c("div", { staticClass: "galy-header" }, [
                _vm._v("越库分离追加配置")
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: { "margin-top": "30px", "padding-left": "20px" }
                },
                [
                  _vm._v("\n        越库用户配置：\n        "),
                  _c(
                    "el-upload",
                    {
                      staticStyle: {
                        display: "inline-block",
                        "margin-left": "20px"
                      },
                      attrs: {
                        action: _vm.action1,
                        name: "file",
                        data: { save_type: 1 },
                        "on-success": _vm.importSuccess,
                        "on-error": _vm.importError,
                        "show-file-list": false,
                        "with-credentials": ""
                      }
                    },
                    [
                      _c(
                        "el-button",
                        { attrs: { size: "small", type: "primary" } },
                        [_vm._v("导入")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "success", size: "small" },
                      on: {
                        click: function($event) {
                          return _vm.exportSetting(1)
                        }
                      }
                    },
                    [_vm._v("\n          下载现有配置\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticStyle: { "font-size": "13px", color: "red" } },
                    [
                      _vm._v(
                        "\n          每次导入，新文件会覆盖旧文件，请下载现有配置后增加新用户id\n        "
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: { "margin-top": "30px", "padding-left": "20px" }
                },
                [
                  _vm._v("\n        订单待配含以下货号时越库：\n        "),
                  _c(
                    "el-upload",
                    {
                      staticStyle: {
                        display: "inline-block",
                        "margin-left": "20px"
                      },
                      attrs: {
                        action: _vm.action1,
                        name: "file",
                        data: { save_type: 2 },
                        "on-success": _vm.importSuccess,
                        "on-error": _vm.importError,
                        "show-file-list": false,
                        "with-credentials": ""
                      }
                    },
                    [
                      _c(
                        "el-button",
                        { attrs: { size: "small", type: "primary" } },
                        [_vm._v("导入")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "success", size: "small" },
                      on: {
                        click: function($event) {
                          return _vm.exportSetting(2)
                        }
                      }
                    },
                    [_vm._v("\n          下载现有配置\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticStyle: { "font-size": "13px", color: "red" } },
                    [
                      _vm._v(
                        "\n          每次导入，新文件会覆盖旧文件，请下载现有配置后增加新货号\n        "
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: { "margin-top": "30px", "padding-left": "20px" }
                },
                [
                  _vm._v("\n        越库商家配置：\n        "),
                  _c(
                    "el-upload",
                    {
                      staticStyle: {
                        display: "inline-block",
                        "margin-left": "20px"
                      },
                      attrs: {
                        action: _vm.action1,
                        name: "file",
                        data: { save_type: 4 },
                        "on-success": _vm.importSuccess,
                        "on-error": _vm.importError,
                        "show-file-list": false,
                        "with-credentials": ""
                      }
                    },
                    [
                      _c(
                        "el-button",
                        { attrs: { size: "small", type: "primary" } },
                        [_vm._v("导入")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "success", size: "small" },
                      on: {
                        click: function($event) {
                          return _vm.exportSetting(4)
                        }
                      }
                    },
                    [_vm._v("\n          下载现有配置\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticStyle: { "font-size": "13px", color: "red" } },
                    [
                      _vm._v(
                        "\n          每次导入，新文件会覆盖旧文件，请下载现有配置后增加新商家id\n        "
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: { "margin-top": "30px", "padding-left": "20px" }
                },
                [
                  _vm._v("\n        订单待发商品大于多少件时越库：\n        "),
                  _c("el-input", {
                    staticStyle: { width: "140px" },
                    attrs: { placeholder: "输入后回车保存", size: "small" },
                    nativeOn: {
                      keypress: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.changeSurpassOrderNeedNum.apply(
                          null,
                          arguments
                        )
                      }
                    },
                    model: {
                      value: _vm.surpassOrderNeedNum,
                      callback: function($$v) {
                        _vm.surpassOrderNeedNum = $$v
                      },
                      expression: "surpassOrderNeedNum"
                    }
                  })
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c("el-col", { attrs: { span: 7 } }, [
            _c("div", { staticClass: "galy-header" }, [_vm._v("越库限制条件")]),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { "margin-top": "30px", "padding-left": "20px" } },
              [
                _vm._v("\n        是否开启："),
                _c("el-switch", {
                  attrs: { "inactive-value": "0", "active-value": "1" },
                  on: {
                    change: function($event) {
                      return _vm.saveSurpassBanSetting(1)
                    }
                  },
                  model: {
                    value: _vm.surpass_ban.is_open,
                    callback: function($$v) {
                      _vm.$set(_vm.surpass_ban, "is_open", $$v)
                    },
                    expression: "surpass_ban.is_open"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { "margin-top": "30px", "padding-left": "20px" } },
              [
                _vm._v("\n        限制用户配置：\n        "),
                _c(
                  "el-upload",
                  {
                    staticStyle: {
                      display: "inline-block",
                      "margin-left": "20px"
                    },
                    attrs: {
                      action: _vm.action2,
                      name: "file",
                      data: { save_type: 2 },
                      "on-success": _vm.importSuccess,
                      "on-error": _vm.importError,
                      "show-file-list": false,
                      "with-credentials": ""
                    }
                  },
                  [
                    _c(
                      "el-button",
                      { attrs: { size: "small", type: "primary" } },
                      [_vm._v("导入")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { type: "success", size: "small" },
                    on: {
                      click: function($event) {
                        return _vm.exportSurpassBanSetting(1)
                      }
                    }
                  },
                  [_vm._v("下载现有配置")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { "font-size": "13px", color: "red" } },
                  [
                    _vm._v(
                      "\n          每次导入，新文件会覆盖旧文件，请下载现有配置后增加新用户id\n        "
                    )
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { "margin-top": "30px", "padding-left": "20px" } },
              [
                _vm._v("\n        限制收件地市：\n        "),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "small" },
                    on: { click: _vm.selectRegionCall }
                  },
                  [_vm._v("\n          添加限制地市\n        ")]
                ),
                _vm._v(" "),
                _vm.surpass_ban.area_text.length > 0
                  ? _c(
                      "div",
                      { staticStyle: { display: "inline-block" } },
                      [
                        _vm._v("\n          限制单件分离："),
                        _c("el-switch", {
                          on: {
                            change: function($event) {
                              return _vm.saveSurpassBanSetting(6)
                            }
                          },
                          model: {
                            value: _vm.surpass_ban.area_restrict_single_detach,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.surpass_ban,
                                "area_restrict_single_detach",
                                $$v
                              )
                            },
                            expression:
                              "surpass_ban.area_restrict_single_detach"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { display: "inline-block" } },
                  [
                    _vm._v("\n          限制质检分离："),
                    _c("el-switch", {
                      attrs: { "active-value": 1, "inactive-value": 0 },
                      on: {
                        change: function($event) {
                          return _vm.saveSurpassBanSetting(8)
                        }
                      },
                      model: {
                        value: _vm.surpass_ban.area_restrict_quality_detach,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.surpass_ban,
                            "area_restrict_quality_detach",
                            $$v
                          )
                        },
                        expression: "surpass_ban.area_restrict_quality_detach"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { display: "inline-block" } },
                  [
                    _vm._v(
                      "\n          限制停发地区自动生成质检汇总任务：\n          "
                    ),
                    _c("el-switch", {
                      attrs: { "active-value": 1, "inactive-value": 0 },
                      on: {
                        change: function($event) {
                          return _vm.saveSurpassBanSetting(9)
                        }
                      },
                      model: {
                        value: _vm.surpass_ban.area_quality_limit,
                        callback: function($$v) {
                          _vm.$set(_vm.surpass_ban, "area_quality_limit", $$v)
                        },
                        expression: "surpass_ban.area_quality_limit"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "tag-group",
                    staticStyle: {
                      border: "1px solid #eee",
                      "max-height": "350px",
                      overflow: "auto"
                    }
                  },
                  _vm._l(_vm.surpass_ban.area_text, function(item) {
                    return _c(
                      "el-tag",
                      {
                        key: item.value,
                        staticStyle: { margin: "3px 3px 0 0" },
                        attrs: { effect: "plain", closable: "" },
                        on: {
                          close: function($event) {
                            return _vm.removeBanArea(item.value)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n            " + _vm._s(item.label) + "\n          "
                        )
                      ]
                    )
                  }),
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  "margin-top": "30px",
                  "padding-left": "20px",
                  display: "flex"
                }
              },
              [
                _c("div", [_vm._v("库存仓区占比配置：")]),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _vm._v("\n          波次待发件数大于"),
                    _c("el-input", {
                      staticStyle: { width: "50px" },
                      attrs: { size: "mini" },
                      nativeOn: {
                        keydown: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.tryToSave.apply(null, arguments)
                        }
                      },
                      model: {
                        value: _vm.surpass_ban.wave_wait_out_num,
                        callback: function($$v) {
                          _vm.$set(_vm.surpass_ban, "wave_wait_out_num", $$v)
                        },
                        expression: "surpass_ban.wave_wait_out_num"
                      }
                    }),
                    _c("br"),
                    _c("br"),
                    _vm._v("\n          且发货仓区件数大于"),
                    _c("el-input", {
                      staticStyle: { width: "50px" },
                      attrs: { size: "mini" },
                      nativeOn: {
                        keydown: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.tryToSave.apply(null, arguments)
                        }
                      },
                      model: {
                        value: _vm.surpass_ban.out_storage_num,
                        callback: function($$v) {
                          _vm.$set(_vm.surpass_ban, "out_storage_num", $$v)
                        },
                        expression: "surpass_ban.out_storage_num"
                      }
                    }),
                    _vm._v("%\n        ")
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { "margin-top": "30px", "padding-left": "20px" } },
              [
                _vm._v(
                  "\n        同纬度订单有已锁定未出库的越库波次不再生成越库波次："
                ),
                _c("el-switch", {
                  attrs: { "inactive-value": "0", "active-value": "1" },
                  on: {
                    change: function($event) {
                      return _vm.saveSurpassBanSetting(7)
                    }
                  },
                  model: {
                    value: _vm.surpass_ban.dimension_limit,
                    callback: function($$v) {
                      _vm.$set(_vm.surpass_ban, "dimension_limit", $$v)
                    },
                    expression: "surpass_ban.dimension_limit"
                  }
                })
              ],
              1
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { staticStyle: { border: "1px solid #ccc" } },
        [
          _c(
            "el-col",
            { staticStyle: { height: "100%" }, attrs: { span: 24 } },
            [
              _c("div", { staticClass: "galy-header" }, [_vm._v("全越配置")]),
              _vm._v(" "),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "div",
                        { staticClass: "box-card", attrs: { shadow: "never" } },
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-card",
                                    { staticClass: "box-card" },
                                    [
                                      _c(
                                        "el-row",
                                        [
                                          _c(
                                            "el-col",
                                            {
                                              staticClass: "mb-3",
                                              attrs: { span: 24 }
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  "早上脚本配货普通波次改为越库波次（早上脚本配货完成后，符合下方条件的波次，将会直接生成越库波次）"
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("el-switch", {
                                                attrs: {
                                                  "active-value": "1",
                                                  "inactive-value": "2"
                                                },
                                                model: {
                                                  value:
                                                    _vm.quanyueConfig.open_cli,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.quanyueConfig,
                                                      "open_cli",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "quanyueConfig.open_cli"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-col",
                                            {
                                              staticClass: "mb-3",
                                              attrs: { span: 24 }
                                            },
                                            [
                                              _c(
                                                "span",
                                                [
                                                  _vm._v(
                                                    "当波次所含商品数量在\n                        "
                                                  ),
                                                  _c("el-input-number", {
                                                    attrs: {
                                                      min: 1,
                                                      size: "small"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.quanyueConfig
                                                          .cli_num_min,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.quanyueConfig,
                                                          "cli_num_min",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "quanyueConfig.cli_num_min"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", [_vm._v(" - ")]),
                                                  _vm._v(" "),
                                                  _c("el-input-number", {
                                                    attrs: {
                                                      min: 1,
                                                      size: "small"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.quanyueConfig
                                                          .cli_num_max,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.quanyueConfig,
                                                          "cli_num_max",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "quanyueConfig.cli_num_max"
                                                    }
                                                  }),
                                                  _vm._v(
                                                    "\n                        区间时，将自动改为越库波次"
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-col",
                                            {
                                              staticClass: "mb-3",
                                              attrs: { span: 24 }
                                            },
                                            [
                                              _c(
                                                "span",
                                                [
                                                  _vm._v(
                                                    "波次商品超过配置的最大值时，则判断今日配货率小于\n                        "
                                                  ),
                                                  _c("el-input-number", {
                                                    attrs: {
                                                      min: 0,
                                                      max: 100,
                                                      size: "small"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.quanyueConfig
                                                          .cli_allot_rate,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.quanyueConfig,
                                                          "cli_allot_rate",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "quanyueConfig.cli_allot_rate"
                                                    }
                                                  }),
                                                  _vm._v(
                                                    "\n                        %，那么仍改为越库波次。（今日配货率=波次所含商品数/未发货订单订货商品数量）"
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "box-card", attrs: { shadow: "never" } },
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-card",
                                    { staticClass: "box-card" },
                                    [
                                      _c(
                                        "el-row",
                                        [
                                          _c(
                                            "el-col",
                                            {
                                              staticClass: "mb-3",
                                              attrs: { span: 24 }
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  "点货商品配到波次为普通波次，则改为越库波次 "
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("el-switch", {
                                                attrs: {
                                                  "active-value": "1",
                                                  "inactive-value": "2"
                                                },
                                                model: {
                                                  value:
                                                    _vm.quanyueConfig.open_api,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.quanyueConfig,
                                                      "open_api",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "quanyueConfig.open_api"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-col",
                                            {
                                              staticClass: "mb-3",
                                              attrs: { span: 24 }
                                            },
                                            [
                                              _c(
                                                "span",
                                                [
                                                  _vm._v(
                                                    "波次已有商品小于等于\n                        "
                                                  ),
                                                  _c("el-input-number", {
                                                    attrs: {
                                                      min: 1,
                                                      size: "small"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.quanyueConfig
                                                          .api_wp_num,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.quanyueConfig,
                                                          "api_wp_num",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "quanyueConfig.api_wp_num"
                                                    }
                                                  }),
                                                  _vm._v(
                                                    "\n                        时，则将普通波次改为越库波次。"
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-col",
                                            {
                                              staticClass: "mb-3",
                                              attrs: { span: 24 }
                                            },
                                            [
                                              _c(
                                                "span",
                                                [
                                                  _vm._v(
                                                    "波次商品大于\n                        " +
                                                      _vm._s(
                                                        "" +
                                                          _vm.quanyueConfig
                                                            .api_wp_num
                                                      ) +
                                                      "\n                        时，且今日配货率小于\n                        "
                                                  ),
                                                  _c("el-input-number", {
                                                    attrs: {
                                                      min: 0,
                                                      max: 100,
                                                      size: "small"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.quanyueConfig
                                                          .api_allot_rate,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.quanyueConfig,
                                                          "api_allot_rate",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "quanyueConfig.api_allot_rate"
                                                    }
                                                  }),
                                                  _vm._v(
                                                    "\n                        %,那么普通波次改为越库波次"
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          staticStyle: { margin: "20px" },
                          attrs: { type: "primary" },
                          on: { click: _vm.saveQuanyueConfig }
                        },
                        [_vm._v("保存")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("select-region", {
        ref: "selectRegionRef",
        on: { submit: _vm.regionSubmit }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-026bb792", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-026bb792","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/wavepicking/OnlyDabiaoSetting.vue
// module id = null
// module chunks = 